// Which stored plugin ids the registry no longer knows about — a persisted
// install list can drift from what the registry currently holds (a plugin was
// removed, a pack was unpublished, the registry is unreachable). A stale id is
// one that was stored but is not named by any manifest in the registry.

// Returns the subset of `storedIds`, in stored order, whose id is absent from
// `registry`. When the registry could not be read (`registryError`) or came
// back empty, nothing can be declared stale, so the result is empty.
export function staleIds(storedIds, registry, registryError) {
  if (registryError || !registry?.length) return []
  const known = new Set(registry.map((m) => m.id))
  return storedIds.filter((id) => !known.has(id))
}
